import { ComparitorData, ResolutionKeys, StateToShow } from "../types";
import { get_parameters } from "./backend_handlers";

export function parameterPrettyText(
    to_show_parameters: StateToShow | undefined
  ): string | undefined {
    if(!to_show_parameters) return undefined
    if ( Object.keys(to_show_parameters).length === 0 ) return undefined;
  
    return Object.entries(to_show_parameters)
      .sort(([keyA], [keyB]) => {
        const numA = parseInt(keyA.split("_").pop() || "0", 10);
        const numB = parseInt(keyB.split("_").pop() || "0", 10);
        return numA - numB; // Sort in ascending order
      })
      .map(([, param]) => param.titles[param.codes.indexOf(param.current_code)])
      .filter(code => code !== undefined)
      .join(" - ");
  }

export function hashObject(obj: any): string {
    // Sort keys for consistent hashing
    const sortedObj = Object.keys(obj).sort().reduce((result, key) => {
      result[key] = obj[key];
      return result;
    }, {} as any);
    
    const str = JSON.stringify(sortedObj);
    
    // Simple hash function (djb2)
    let hash = 5381;
    for (let i = 0; i < str.length; i++) {
      hash = ((hash << 5) + hash) + str.charCodeAt(i);
      hash = hash & hash; // Convert to 32-bit integer
    }
    
    return Math.abs(hash).toString(16);
  }

export function createComparitorDataMessage( ComparitorData: ComparitorData, current_resolution : ResolutionKeys, equationNumber: number) : any{
  //0 equation_fresh_surface_water
  //1 equation_fresh_ground_water
  //2 equation_brackish_ground_water


  let selectedEquation = "";
  switch (equationNumber) {
    case 0: selectedEquation = ComparitorData.equation_fresh_surface_water; break;
    case 1: selectedEquation = ComparitorData.equation_fresh_ground_water; break;
    case 2: selectedEquation = ComparitorData.equation_brackish_ground_water; break;
    default: throw new Error("Invalid equation number. Must be 0, 1, or 2.");
  }

  const transformedVariables: { [key: string]: any } = Object.fromEntries(
    Object.entries(ComparitorData.variables).map(([key, value]: [string, any]) => [
      key,
      {
        ...value,
        parameter: get_parameters(value.parameter),
      },
    ])
  );

  return {
    variables: transformedVariables,
    equation: selectedEquation,
    resolution: current_resolution
  };
};

export function convertToMap(bucketValues: any, key: "fgw" | "bgw" | "fsw") {
  const resultMap: { [key: string]: "High" | "Medium" | "Low" } = {};
  bucketValues[key][0].forEach((item: string) => resultMap[item] = "High");
  bucketValues[key][1].forEach((item: string) => resultMap[item] = "Medium");
  bucketValues[key][2].forEach((item: string) => resultMap[item] = "Low");
  return resultMap;
};